import { Button } from 'antd';
import styled from 'styled-components';

export const TreeLabel = styled.div<{
  token: any;
}>`
  display: inline-block;
  align-self: flex-start;
  padding: 0px 8px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 6px 6px 0 0;
  text-transform: uppercase;
  background: ${(props) => props.token.actionButtonsHover};
  color: rgb(255, 255, 255);
  margin-bottom: 0;
`;

const levelOpacity: Record<number, string> = {
  0: '100%',
  1: '75%',
  2: '50%',
  3: '30%'
};

export const TreeValue = styled.div<{
  token: any;
  level?: number;
}>`
  background: color-mix(
    in srgb,
    ${({ token }) => token.colorPrimary}
      ${({ level = 0 }) => levelOpacity[level] ?? '30%'},
    transparent
  );
  border-radius: 0 12px 12px 12px;
  padding: 12px 20px;
  min-width: 450px;
  max-width: 450px;
  font-size: 20px;
  color: #ffffff;
`;

export const TreeNodeWrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const StyledInfoButton = styled(Button)`
  margin-left: 10px;
  border: none;
  font-size: 18px;
  color: white;
`;

export const PopoverContent = styled.div`
  max-width: min(420px, 80vw);
  max-height: 60vh;
  overflow-y: auto;
  word-break: break-word;

  p {
    margin-bottom: 8px;
    line-height: 1.4;
  }

  b {
    font-weight: 600;
  }

  @media (max-width: 768px) {
    max-width: 280px;
    font-size: 13px;

    p {
      margin-bottom: 6px;
    }
  }
`;
